import HubspotLogo from '@clearkit/icons/services/Hubspot';

import hubspotTheme from './theme';

export default {
  logo: HubspotLogo,
  theme: hubspotTheme,
};
